export const DEBOUNCE_MS = 1000 // Wait before dispatching (fast user motion)
export const THROTTLE_MS = 3000 // Don’t send updates more than once every 3s
export const DISTANCE_THRESHOLD_METERS = 15 // Only send if user moved 25+ meters
